/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/video/video.jwplayer.freewheel.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'video/jwplayer/freewheel', exports: {} };
const exports = module.exports;



import { Fandango_debugLog as debugLog } from '@take-2/fd-modules/splits/require-core';



import { Fandango_cookie as Fandango_cookie_get_getCookie } from '@take-2/fd-modules/splits/require-core';

const { get: getCookie } = Fandango_cookie_get_getCookie;


import { Fandango as Fandango_fwPlayer } from '@take-2/fd-modules/splits/require-core';

const { fwPlayer } = Fandango_fwPlayer;


import { global_consts as global_consts_CookieNames } from '@take-2/fd-modules/splits/require-core';

const { CookieNames } = global_consts_CookieNames;


const RegExes = {
    ID_CHARS: /[xy]/g,
}
/**
 * @returns {string} unique GUID-like key built of about 31 random numbers
 */
function newClientToken() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(RegExes.ID_CHARS, (char) => {
        const rnd = Math.random() * 16 | 0;
        char = char === 'x' ? rnd : (rnd & 0x3 | 0x8);
        return char.toString(16);
    });
}
function loadPixel(fwUserID, fwSyncPixelURL, napiSyncPixelURL) {
    if (!fwUserID || !fwSyncPixelURL || !napiSyncPixelURL) {
        return;
    }
    const redirectURL = encodeURIComponent(napiSyncPixelURL + fwUserID);
    const pixel = document.createElement('img');
    pixel.id = 'fw_' + fwUserID;
    pixel.src = fwSyncPixelURL + redirectURL;
    pixel.style.width = '1px';
    pixel.style.height = '1px';
    pixel.style.display = 'none';
    document.getElementsByTagName('body')[0].appendChild(pixel);
}
function init(cb) {
    const { enabled, fwSyncPixelURL, napiSyncPixelURL } = fwPlayer || {};
    if (!enabled) {
        return debugLog.info(module.name, 'not enabled');
    }
    let fwUserID = getCookie(CookieNames.FREEWHEEL_USER_ID);
    if (!fwUserID) {
        fwUserID = newClientToken();
        loadPixel(fwUserID, fwSyncPixelURL, napiSyncPixelURL);
    }
    typeof cb === 'function' && cb(fwUserID);
}
export default {
    init
};
